import React, { FunctionComponent } from "react"
import Select from "react-select"
import RoleTemplateTypes from "src/pages/hr/Types/RoleTemplateTypes"
import RoleAssignmentSearchRoles from "../RoleAssignmentContent/RoleAssignmentAllRoles/RoleAssignmentSearchRoles/RoleAssignmentSearchRoles"
import roleAssignmentHelper from "../Utils/RoleAssignmentHelper"
import selectMenuStyles from "../Utils/SelectMenuStyles"
import { Button, OverlayTrigger, Spinner } from "react-bootstrap"
import "./RoleAssignmentHeader.css"

interface RoleAssignmentHeaderProps {
    manageParentState: Function
    callParentFunction: Function
    templates: RoleTemplateTypes[]
    templateDex: number
    readonly: boolean
    busy: boolean

}

const RoleAssignmentHeader: FunctionComponent<RoleAssignmentHeaderProps> = (props) => {

    const { manageParentState, callParentFunction, templates, templateDex, readonly, busy } = props
    const { addOrRemoveTemplate, buildHashTable, grantedRolesCopy, allRolesCopy, rasTooltip } = roleAssignmentHelper

    return (
        <div className="RoleAssignmentHeader">
            <div className="RoleAssignmentHeaderFlexBox RoleAssignmentHeaderFlexBoxLeft">
                {templates.length > 0 && <Select
                    id="b8231f564c84d8fa84f21ad0becfb2e"
                    placeholder={"Select a template"}
                    value={{ label: templateDex > -1 ? templates[templateDex].Template.Name : "Select a template..." }}
                    options={templates.map((t, i) => ({ value: i, label: t.Template.Name }))}
                    onChange={(selectedItem: { value: number, label: string } | null) => {
                        if (selectedItem) {
                            addOrRemoveTemplate(templates[selectedItem.value].RoleTemplatePortalRoleLnk, "+")
                            manageParentState([{ key: "templateDex", value: selectedItem.value }])
                        } else {
                            buildHashTable(grantedRolesCopy, allRolesCopy)
                            manageParentState([{ key: "templateDex", value: -1 }])
                        }
                    }}
                    styles={selectMenuStyles}
                    isDisabled={readonly || busy}
                // isClearable={templateDex > -1}
                />}
                {(!readonly && !busy) && <OverlayTrigger placement="left" overlay={rasTooltip("reset roles")}>
                    <div className="RoleAssignmentHeaderFlexBoxLeftResetRoles"
                        onClick={() => {
                            buildHashTable(grantedRolesCopy, allRolesCopy)
                            manageParentState([{ key: "templateDex", value: -1 }])
                        }}
                    >
                        <span className="material-icons-outlined">restart_alt</span>
                    </div>
                </OverlayTrigger>}
            </div>
            <div className="RoleAssignmentHeaderFlexBox RoleAssignmentHeaderFlexBoxMiddle">

            </div>
            <div className="RoleAssignmentHeaderFlexBox RoleAssignmentHeaderFlexBoxRight">
                {!busy && <RoleAssignmentSearchRoles
                    manageParentState={manageParentState}
                />}
                <div className="RoleAssignmentHeaderFlexBoxRightSaveBtn">
                    {busy && <Spinner id="d892ede1d14d15b13d485774b3ce5a" animation="border" />}
                    {!busy && <Button disabled={busy || readonly} onClick={() => callParentFunction("updateRoles", null, null)}>Save</Button>}
                </div>
            </div>
        </div>
    )
}

export default RoleAssignmentHeader